import css from './ErrorMessage.module.css';

const ErrorMessage = ({ error }) => {
  return <div className={css.error_message}>{error ?? 'Немає даних'}</div>;
};

export default ErrorMessage;
